const filesToBase64 = async (files) => {
  let result = [];
  function previewFileAsync(file) {
    return new Promise((res) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => res(reader.result);
    });
  }
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const base64Encoded = await previewFileAsync(file);
    /**
     * Remove type from base64 encoded string. (e.g. data:image/png;base64)
     *  */
    result.push(base64Encoded.split(',')[1]);
  }
  return result;
};

export { filesToBase64 };
